import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
} from "@mui/material";
import React from "react";

import { SafeArgonButton, SafeArgonInput } from "0.Mine/4.Argon/ArgonComponents";

import { NewNote } from "../sharedTypes";

interface AddNoteDialogProps {
  open: boolean;
  onClose: () => void;
  newNote: NewNote;
  handleNoteInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleAddNote: () => void;
  setNewNote: React.Dispatch<React.SetStateAction<NewNote>>;
  analyzeActivities?: () => void;
}

const AddNoteDialog: React.FC<AddNoteDialogProps> = ({
  open,
  onClose,
  newNote,
  handleNoteInputChange,
  handleAddNote,
  setNewNote,
  analyzeActivities,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Aggiungi note attivita</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 0.5 }}>
          <Grid item xs={12}>
            <SafeArgonInput
              label="Title"
              name="title"
              value={newNote.title}
              onChange={handleNoteInputChange}
              fullWidth
              placeholder="Dai un titolo alla nota"
              required
            />
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth variant="outlined">
              <InputLabel id="activity-type-label">Activity Type</InputLabel>
              <Select
                labelId="activity-type-label"
                name="type"
                value={newNote.type}
                onChange={(e) => setNewNote({ ...newNote, type: e.target.value as any })}
                label="Tipo di attività"
              >
                <MenuItem value="note">Note</MenuItem>
                <MenuItem value="call">Chiamata</MenuItem>
                <MenuItem value="email">Email</MenuItem>
                <MenuItem value="meeting">Meeting</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <SafeArgonInput
              multiline
              rows={4}
              label="Description"
              name="description"
              value={newNote.description}
              onChange={handleNoteInputChange}
              fullWidth
              placeholder="Scrivi una descrizione sulla nota attività..."
              required
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        {/*<SafeArgonButton
                    variant="contained"
                    color="info"
                    onClick={analyzeActivities}
                >
                    Esamina con AI
                </SafeArgonButton>*/}

        <SafeArgonButton variant="outlined" color="secondary" onClick={onClose}>
          Cancella
        </SafeArgonButton>
        <SafeArgonButton
          variant="contained"
          color="success"
          onClick={handleAddNote}
          disabled={!newNote.title || !newNote.description}
        >
          Aggiungi attivita
        </SafeArgonButton>
      </DialogActions>
    </Dialog>
  );
};

export default AddNoteDialog;
